import * as React from 'react';
export default function SvgBadge2() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.705 5.23a2 2 0 012.595 0l.621.53c.321.273.72.438 1.14.472l.813.065a2 2 0 011.835 1.835l.065.813a2 2 0 00.471 1.139l.53.621a2 2 0 010 2.595l-.53.622a2 2 0 00-.471 1.138l-.065.814a2 2 0 01-1.835 1.835l-.814.065c-.42.033-.818.198-1.139.471l-.62.53a2 2 0 01-2.596 0l-.621-.53a2.001 2.001 0 00-1.139-.471l-.813-.065a2 2 0 01-1.836-1.835l-.064-.814a2 2 0 00-.472-1.138l-.53-.622a2 2 0 010-2.595l.53-.621c.273-.32.438-.719.472-1.139l.064-.813a2 2 0 011.836-1.835l.813-.065a2 2 0 001.139-.472l.621-.53z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}